export const SCORING_MUTATION_STATUS = Object.freeze({
  SUBMITTING: 'submitting',
  OUTCOME_UNKNOWN: 'outcomeUnknown',
  CHECKING_OUTCOME: 'checkingOutcome',
  RETRYING: 'retrying',
  RECOVERY_REQUIRED: 'recoveryRequired',
});

export const classifyScoringMutationError = (error) => {
  const status = Number(error?.status);
  const code = error?.code || error?.payload?.code || '';
  if (code === 'SCORE_STATE_CHANGED') return 'stateChanged';
  if (code === 'IDEMPOTENCY_KEY_REUSED' || code === 'UNDO_TARGET_CHANGED') return 'confirmedRejection';
  if ([400, 401, 403, 404].includes(status)) return 'confirmedRejection';
  if (code === 'SCORE_MUTATION_IN_PROGRESS' || status === 202) return 'inProgress';
  if (!status || [408, 502, 503, 504].includes(status)) return 'unknownOutcome';
  return 'confirmedRejection';
};

export const recoveryDelayMs = (attempt) => [300, 700, 1500, 3000][Math.min(Math.max(Number(attempt) || 0, 0), 3)];

